module.exports = __webpack_public_path__ + "static/media/team_1.6427255e.png";